export default {
  'Watermark': 'Wasserzeichen',
  'Add Watermark Selection': 'Wasserzeichen Auswahl hinzufügen',
}